/* Danachi 2026 - pointer-driven 3D tilt + specular sweep.
   Desktop / fine-pointer only; no-ops for touch and reduced motion. */
(function () {
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (!fine.matches || reduced.matches) return;

  var SELECTOR = '[data-d-tilt], .card-wrapper, .d-uni__card';
  var MAX = 7; /* degrees */

  function bind(el) {
    if (el.dataset.dTiltBound) return;
    el.dataset.dTiltBound = '1';
    el.classList.add('d-tilt');

    var raf = 0;
    var rect = null;

    function measure() { rect = el.getBoundingClientRect(); }

    function move(e) {
      if (!rect) measure();
      var px = (e.clientX - rect.left) / rect.width;
      var py = (e.clientY - rect.top) / rect.height;
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        el.style.setProperty('--d-rx', ((0.5 - py) * MAX).toFixed(2) + 'deg');
        el.style.setProperty('--d-ry', ((px - 0.5) * MAX).toFixed(2) + 'deg');
        el.style.setProperty('--d-mx', (px * 100).toFixed(1) + '%');
        el.style.setProperty('--d-my', (py * 100).toFixed(1) + '%');
      });
    }

    function enter() { measure(); el.classList.add('is-tilting'); }

    function leave() {
      el.classList.remove('is-tilting');
      el.style.setProperty('--d-rx', '0deg');
      el.style.setProperty('--d-ry', '0deg');
    }

    el.addEventListener('pointerenter', enter);
    el.addEventListener('pointermove', move);
    el.addEventListener('pointerleave', leave);
  }

  function scan(scope) {
    (scope || document).querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState !== 'loading') scan();
  else document.addEventListener('DOMContentLoaded', function () { scan(); });

  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });

  /* cards injected later (quick add, facet reloads, infinite scroll) */
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (added[j].nodeType === 1) scan(added[j]);
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
